/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [":host{display:block;height:100%;width:100%}.gallery-cards{display:block;height:100%;width:100%}.gallery-cards__loading{display:flex;justify-content:center;margin-top:20vh}.gallery-cards__content{display:block;padding:1px;height:100%}.gallery-cards__content .scrollable-content{display:grid;padding:1px;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));grid-auto-rows:364px;grid-auto-flow:row;justify-content:center}.gallery-cards__content .scrollable-content app-gallery-card{padding:16px}"];
export { styles as styles };
